import React, { FC, useMemo } from "react";
import { DesktopOutlined, UserOutlined } from "@ant-design/icons";
import { UserOverviewItem } from "shared/api";
import { BaseOverviewCard, AssignedItem } from "./BaseOverviewCard";

const UserCard: FC<{ item: UserOverviewItem }> = ({ item }) => {
  const {
    user_name,
    user_profile_image,
    user_image_base64,
    user_image_filename,
    open_tasks,
    max_priority,
    max_days_overdue,
    tasks_by_machine,
  } = item;

  const assignedItems: AssignedItem[] = useMemo(() => {
    return Object.entries(tasks_by_machine ?? {}).map(([name, count]) => ({
      name,
      count,
    }));
  }, [tasks_by_machine]);

  let imageSrc: string | null = null;

  if (user_profile_image) {
    imageSrc = user_profile_image;
  } else if (user_image_base64) {
    imageSrc = `data:image/${
      user_image_filename?.split(".").pop() ?? "png"
    };base64,${user_image_base64}`;
  }

  return (
    <BaseOverviewCard
      title={user_name}
      coverImage={imageSrc}
      coverFallbackIcon={<UserOutlined className="text-5xl text-neutral-300" />}
      openTasks={open_tasks}
      maxPriority={max_priority}
      maxDaysOverdue={max_days_overdue}
      assignedItems={assignedItems}
      assignedTitle="By Machine"
      assignedEmptyText="No machines assigned"
      assignedItemIcon={
        <DesktopOutlined className="shrink-0 text-neutral-400" />
      }
      filterKey="user"
      filterValue={user_name}
    />
  );
};

export { UserCard };
